<adapt-display-accordion-hierarchy class="team-tab-content"
                                   [hierarchy]="teamsHierarchy$ | async"></adapt-display-accordion-hierarchy>
